export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getAuthHeaders = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("adminToken")}` }
});

export const getMemberHeaders = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("memberToken")}` }
});

/**
 * Single shared function for every membership checkout entry point.
 * Passes include_diet_plan so every path behaves identically and can't drift.
 */
export const startMembershipCheckout = async ({
  planId, memberId, originUrl, token = null, includeDietPlan = false,
}) => {
  const { default: axios } = await import("axios");
  const headers = token ? { Authorization: `Bearer ${token}` } : {};
  const response = await axios.post(
    `${API}/payments/checkout`,
    { package_type: planId, member_id: memberId, origin_url: originUrl, include_diet_plan: includeDietPlan },
    { headers }
  );
  window.location.href = response.data.url;
};
